export default {"src":"/_next/static/media/delhi.e349dc80.svg","height":336,"width":286,"blurWidth":0,"blurHeight":0};